var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTyCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 73,
    viewBox: "0 0 65 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21624_3472)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21624_3472",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: 0,
    width: 111,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-21.6665 0H88.6191V111.473H-21.6665V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21624_3472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 72.3264C49.7325 72.3264 63.9911 57.9143 63.9911 40.1354C63.9911 22.3566 49.7328 7.94443 32.1434 7.94443C14.5544 7.94443 0.29541 22.3566 0.29541 40.1354C0.29541 57.9143 14.554 72.3264 32.1431 72.3264Z",
    fill: "#1EE576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 8.91999C15.1143 8.91999 1.26046 22.923 1.26046 40.1352C1.26046 57.3478 15.1147 71.3508 32.1435 71.3508C49.1727 71.3508 63.0261 57.3478 63.0261 40.1352C63.0261 22.923 49.1723 8.91999 32.1431 8.91999ZM32.1431 73.302C14.0498 73.302 -0.669922 58.4234 -0.669922 40.1352C-0.669922 21.8478 14.0501 6.96921 32.1439 6.96921C50.2372 6.96921 64.9569 21.8478 64.9569 40.1356C64.9569 58.4242 50.2368 73.3028 32.1435 73.3028",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1051 62.9419C44.4709 62.9419 54.4954 52.8095 54.4954 40.3105C54.4954 27.8116 44.4709 17.6795 32.1051 17.6795C19.7393 17.6795 9.71484 27.8116 9.71484 40.3109C9.71484 52.8095 19.7393 62.9423 32.1051 62.9423",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1049 18.6555C20.2913 18.6555 10.6804 28.3703 10.6804 40.3115C10.6804 52.2523 20.2917 61.9671 32.1053 61.9671C43.9188 61.9671 53.5305 52.2519 53.5305 40.3111C53.5305 28.3703 43.9188 18.6551 32.1053 18.6551M32.1053 63.9179C19.2271 63.9179 8.75 53.3279 8.75 40.3111C8.75 27.2942 19.2271 16.7043 32.1053 16.7043C44.9834 16.7043 55.4605 27.2942 55.4605 40.3111C55.4605 53.3279 44.9834 63.9179 32.1053 63.9179Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0188 43.5307C18.1598 42.6625 17.7256 41.6383 17.7256 40.4775C17.7256 39.3163 18.1598 38.1555 19.0188 37.424C19.8777 36.6925 20.8913 36.1169 22.0401 36.1169C23.1882 36.1169 24.3366 36.5558 25.0603 37.424L28.5056 40.9068L38.707 30.5959C39.5656 29.7273 40.5796 29.2884 41.7276 29.2884C42.8764 29.2884 44.0245 29.7273 44.7479 30.5959C46.4757 32.3419 46.4757 35.1024 44.7479 36.7021L28.5056 53.1193L19.0188 43.5307Z",
    fill: "#1EE576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7037 42.8384C18.4684 41.541 18.2562 39.3657 19.7037 38.1171C21.1512 36.8684 23.0238 36.712 24.3748 38.1171C25.5045 39.2976 26.6716 40.4386 27.8201 41.5994C28.1869 41.9702 28.8146 41.9702 29.181 41.5994L35.4252 35.2884L38.8705 31.8057C39.1117 31.5618 39.3434 31.3083 39.6042 31.0737C40.704 30.1084 42.4896 29.9327 43.6671 30.879C44.7095 31.7182 45.3176 33.1422 44.9794 34.4787C44.806 35.1514 44.4292 35.6391 43.947 36.1171L41.8623 38.2247L33.7073 46.4671L29.9239 50.2909C29.258 50.9644 28.5247 51.5984 27.9166 52.3202C27.8879 52.3589 27.8492 52.3883 27.8201 52.4178H29.181L20.8813 44.0286L19.6942 42.8287C18.8161 41.9412 17.4456 43.3164 18.3332 44.204L26.6334 52.5935L27.8205 53.793C28.1869 54.1638 28.8146 54.1638 29.181 53.793L34.4215 48.4961C37.2878 45.5989 40.1445 42.7018 43.0108 39.8143C43.7728 39.0437 44.5257 38.273 45.2885 37.5121C47.0159 35.7858 47.5371 33.2687 46.3017 31.0644C44.5548 27.9525 40.5117 27.445 38.002 29.9133C37.1622 30.7424 36.3515 31.5815 35.5217 32.4203L31.044 36.9466C30.0208 37.98 28.9497 38.9756 27.9752 40.0485C27.9269 40.1065 27.8687 40.1557 27.8109 40.2145H29.1718C28.0426 39.0727 26.8937 37.9514 25.784 36.7906C24.6743 35.6294 23.2172 34.9857 21.615 35.1514C19.8102 35.3368 17.9284 36.5855 17.1947 38.2827C16.2975 40.3411 16.7992 42.6139 18.3144 44.204C19.1734 45.1112 20.5435 43.7259 19.675 42.8287L19.7037 42.8384Z",
    fill: "#222222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21624_3472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyCheck);
export default __webpack_public_path__ + "static/media/ty-check.250b29a1994462867c34a38fb12194e5.svg";
export { ForwardRef as ReactComponent };